module.exports = __webpack_public_path__ + "img/courseDetail.1e2a6b2e.png";